import { Component, Input } from '@angular/core';
import { ServiceLocator } from '../../ServiceLocator';
import { DossierDTO, FavouriteProjectDTO, UserDTO } from '../../api/plyca-dtos';
import { ProjectEntityDTO } from '../../api/plyca-dtos-v2';
import { UIService } from '../../ui.service';
import { Router } from '@angular/router';
import { PlycaDataService } from '../../../services/plyca.service';
import { UserPrefs } from '../../api/UserPrefs-dto';
import { UserService } from '../../user.service';
import { Configuration } from '../../conf/app.constants';
import { Store } from '@ngrx/store';
import { AppState } from '../../store/AppState';
import { Subscription } from '../../../../node_modules/rxjs';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'dossierDetail',
  templateUrl: 'dossierDetail.template.html'
})
export class dossierDetailComponent {
  @Input() dossier: any;
  @Input() infoLink: boolean = true;
  @Input() infoTitulo: boolean = true;
  @Input() showDivisionInfo: boolean = false;


  private plycaService: PlycaDataService;

  userPrefsSubs: Subscription;
  userPrefs: UserPrefs;


  constructor(public uiService: UIService, protected router: Router, private userService: UserService,
    private store: Store<AppState>,
    private translateService: TranslateService,
    public configuration: Configuration) {

    this.plycaService = ServiceLocator.injector.get(PlycaDataService);
    this.userPrefsSubs = this.store
      .select('userPrefs')
      .subscribe((prefs: UserPrefs) => {
        this.userPrefs = prefs;
      });
  }

  openDossier(dossier: DossierDTO, event?: any) {



    //    this.uiService.openDossier(dossierBasicInfoComponent, dossier);


    this.router.navigate(['/dossierInfo/' + dossier.identifier]);

  }

  getSituationClass() {
    let styleClass = 'text-emphasis'; // default class
    switch (this.dossier.situacion) {
      case 0: { // normal
        styleClass = 'text-emphasis';
        break;
      }
      case 4: { // Extingido
        styleClass = 'text-success';
        break;
      }
      case 3: { // Cancelado
        styleClass = 'text-danger';
        break;
      }
      case 5: { // Modo soporte
        styleClass = 'text-secondary';
        break;
      }

    }
    return styleClass;
  }


  getSituationText() {
    let styleClass = this.translateService.instant('DossierDetail.situation.normal');; // default text
    switch (this.dossier.situacion) {
      case 0: { // normal
        styleClass = this.translateService.instant('DossierDetail.situation.normal');
        break;
      }
      case 4: { // Extingido
        styleClass = this.translateService.instant('DossierDetail.situation.terminated');
        break;
      }
      case 3: { // Cancelado
        styleClass = this.translateService.instant('DossierDetail.situation.canceled');
        break;
      }
      case 5: { // Modo soporte
        styleClass = this.translateService.instant('DossierDetail.situation.supportmode');
        break;
      }

    }
    return styleClass;
  }
}

